import { GoogleOAuthProvider } from "@react-oauth/google"
import { useEffect } from "react"

import { useRouter } from "next/router"
import safeLocalStorage from "lib/storage"

import BottomNavigation from "../BottomNavigation"
import DrawerDefault from "../DefaultLayout/DrawerDefault"

export type QiscusAppStorage = "hidden" | "visible" | null

function NoLayout({ children, handleLogout }) {
  const router = useRouter()

  useEffect(() => {
    const localStorageQiscusApp = safeLocalStorage.getItem("qiscusApp") as QiscusAppStorage
    const qiscusApp = document.getElementById("qismo-widget")
    const qiscusAppButtonClose = document.getElementById("qiscus-app-button-close")

    if (localStorageQiscusApp === "hidden") {
      qiscusApp?.classList.add("hidden")
      qiscusAppButtonClose?.classList.add("hidden")
    } else {
      qiscusApp?.classList.remove("hidden")
      qiscusAppButtonClose?.classList.remove("hidden")
    }
  }, [])

  const checkisProgramDetail = () =>
    router.pathname !== "/register" &&
    router.pathname !== "/[category]/inhouse/[program]" &&
    router.pathname !== "/[category]/[type]/[program]/[slug]" &&
    !router.pathname.includes("checkout")

  return (
    <div className="relative min-h-screen">
      <style>
        {`
          .svelte-1xkyjie {
            display: none;
          }
        `}
      </style>
      <div>
        <div>
          <DrawerDefault handleLogout={handleLogout} />
        </div>
        <GoogleOAuthProvider clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}>
          <div className={`min-h-screen ${checkisProgramDetail() ? "pb-[90px] lg:pb-0" : ""}`}>
            {children}
          </div>
        </GoogleOAuthProvider>
      </div>

      <div className="block lg:hidden">{checkisProgramDetail() && <BottomNavigation />}</div>
    </div>
  )
}

export default NoLayout
